export default __webpack_public_path__ + "static/Ultramar-Logo-9b9c9d8c1c6c584ee2b4b53490ada783.png";